<template>
  <div class="product-index-container">
    <h2 class="page-title">产品列表</h2>

    <!-- 查询表单 -->
    <div class="search-form">
      <div class="search-row">
        <div class="search-col">
          <div class="form-group">
            <label for="productName">产品名称</label>
            <el-input id="productName" v-model="search.productName" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="sku">SKU</label>
            <el-input id="sku" v-model="search.sku" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="category">产品分类</label>
            <el-select id="category" v-model="search.categorize" placeholder="请选择分类" :disabled="loading || loadingCategories" style="width: 100%">
              <el-option label="全部" value=""></el-option>
              <el-option v-if="loadingCategories" label="加载分类中..." value="loading" disabled></el-option>
              <el-option v-else-if="categoryError" label="分类加载失败" value="error" disabled></el-option>
              <el-option v-else v-for="category in categories" :key="category.categoryId" :label="category.categoryName" :value="category.categoryId"></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="qualityRating">产品质量评级</label>
            <el-select id="qualityRating" v-model="search.qualityLevel" placeholder="请选择评级" :disabled="loading" style="width: 100%">
              <el-option label="全部" value="0"></el-option>
              <el-option label="高质量" value="1"></el-option>
              <el-option label="普通" value="2"></el-option>
              <el-option label="售后多" value="3"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search-row">
        <div class="search-col">
          <div class="form-group">
            <label for="owner">当前归属人</label>
            <el-input id="owner" v-model="search.salesman" placeholder="准确查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="isMatched">是否对版</label>
            <el-select id="isMatched" v-model="search.matchLevel" placeholder="请选择" :disabled="loading" style="width: 100%">
              <el-option label="全部" value="0"></el-option>
              <el-option label="对版" value="1"></el-option>
              <el-option label="货不对板" value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="publicStatus">是否公品</label>
            <el-select id="publicStatus" v-model="search.publicStatus" placeholder="请选择" :disabled="loading" style="width: 100%">
              <el-option label="全部" value="0"></el-option>
              <el-option label="公司公品" value="1"></el-option>
              <el-option label="个人私品" value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="hasVideo">是否有视频</label>
            <el-select id="hasVideo" v-model="search.hasVideo" placeholder="请选择" :disabled="loading" style="width: 100%">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="有视频" value="1"></el-option>
              <el-option label="无视频" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="hasPic">是否有图片</label>
            <el-select id="hasPic" v-model="search.hasPic" placeholder="请选择" :disabled="loading" style="width: 100%">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="有图片" value="1"></el-option>
              <el-option label="无图片" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-col search-button-col">
          <el-button type="primary" @click="handleSearch" :disabled="loading" :loading="loading">
            查询
          </el-button>
        </div>
      </div>
    </div>

    <!-- 产品表格 -->
    <div class="table-container">
    <table>
      <thead class="sticky-header">
        <tr>
          <th>SKU</th>
          <th>产品图片</th>
          <th>当前归属人</th>
          <th>产品中文名</th>
          <th>产品英文名</th>
          <th>产品分类</th>
          <th>产品质量评级</th>
          <th>是否对版</th>
          <th>是否公品</th>
          <th>总签收率</th>
          <th>投放视频</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <!-- 加载中状态 -->
        <tr v-if="loading">
          <td colspan="12" style="text-align: center; padding: 20px;">
            <span v-if="$loading">
              <el-icon>
                <Loading />
              </el-icon> 加载中...
            </span>
            <span v-else>加载中...</span>
          </td>
        </tr>

        <!-- 错误状态 -->
        <tr v-else-if="error">
          <td colspan="12" style="text-align: center; padding: 20px; color: #f56c6c;">
            {{ error }}
          </td>
        </tr>

        <!-- 无数据状态 -->
        <tr v-else-if="!hasData">
          <td colspan="12" style="text-align: center; padding: 20px;">
            暂无数据
          </td>
        </tr>

        <!-- 数据列表 -->
        <tr v-else v-for="item in products" :key="item.sku">
          <td>{{ item.sku || '-' }}</td>
          <td>
            <img v-if="item.pic" :src="item.pic" class="product-img" alt="产品图片">
            <span v-else>等待上传</span>
          </td>
          <td>{{ item.salesman || '-' }}</td>
          <td>{{ item.skuName || '-' }}</td>
          <td>{{ item.skuNameEn || '-' }}</td>
          <td>{{ item.categorize || '-' }}</td>
          <td>{{ item.qualityLevel || '-' }}</td>
          <td>{{ item.matchLevel || '-' }}</td>
          <td>{{ item.publicStatus || '-' }}</td>
          <td>{{ item.signRate || '-' }}</td>
          <td>
            <a v-if="item.videoUrl" @click.prevent="downloadVideo(item.videoUrl)" href="#" style="color: #409EFF; text-decoration: underline;">下载视频</a>
            <span v-else>等待上传</span>
          </td>
          <td>
            <button class="edit-btn" @click="handleEdit(item.sku)" :disabled="loading">
              编辑
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 分页控件 -->
    <div class="pagination-container" v-if="hasData">
        <div class="page-size-selector">
          <span>每页显示：</span>
          <el-select v-model="pagination.pageSize" @change="handlePageSizeChange" :disabled="loading" size="small" style="width: 100px">
            <el-option label="10条" value="10"></el-option>
            <el-option label="100条" value="100"></el-option>
            <el-option label="1000条" value="1000"></el-option>
          </el-select>
        </div>

        <el-pagination
          @size-change="handlePageSizeChange"
          @current-change="handlePageChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 100, 1000]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next"
          :total="pagination.totalItems"
          :disabled="loading">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductIndex',
  data() {
    return {
      search: {
        productName: '',
        sku: '',
        categorize: '',
        qualityLevel: '0',
        salesman: '',
        matchLevel: '0',
        publicStatus: '0',
        hasVideo: '-1',
        hasPic: '-1'
      },
      categories: [],
      loadingCategories: false,
      categoryError: false,
      products: [],
      loading: false,
      error: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
        startPage: 1,
        endPage: 1,
        pages: []
      }
    };
  },
  computed: {
    hasData() {
      return this.products && this.products.length > 0;
    }
  },
  methods: {
    /**
     * 下载视频文件
     */
    downloadVideo(videoUrl) {
      // 确保URL是完整的
      let fullUrl = videoUrl;
      
      // 如果URL不是完整的http(s)链接，需要构建完整路径
      if (!videoUrl.startsWith('http://') && !videoUrl.startsWith('https://')) {
        // 根据当前环境确定基础URL
        if (process.env.NODE_ENV === 'development') {
          // 开发环境 - 使用代理服务
          fullUrl = videoUrl.startsWith('/') ? videoUrl : '/' + videoUrl;
          // 在开发环境中，链接会通过代理转发到后端服务
          window.open(fullUrl, '_blank');
        } else {
          // 生产环境 
          // 获取当前页面的完整URL作为基准
          const currentOrigin = window.location.origin;
          fullUrl = currentOrigin + (videoUrl.startsWith('/') ? videoUrl : '/' + videoUrl);
          window.open(fullUrl, '_blank');
        }
        return;
      }
      
      // 如果已经是完整URL，检查是否需要将HTTP转换为HTTPS
      try {
        const urlObj = new URL(videoUrl);
        const currentOrigin = window.location.origin;
        
        // 检查当前页面是否使用HTTPS，且视频URL使用HTTP
        if (window.location.protocol === 'https:' && urlObj.protocol === 'http:') {
          // 将HTTP转换为HTTPS
          urlObj.protocol = 'https:';
          fullUrl = urlObj.toString();
          console.log(`已自动将HTTP链接转换为HTTPS: ${videoUrl} -> ${fullUrl}`);
        }
        
        // 如果同源，直接打开
        if (urlObj.origin === currentOrigin) {
          window.open(fullUrl, '_blank');
          return;
        }
        
        // 如果不同源，同样直接打开（浏览器会处理安全策略）
        window.open(fullUrl, '_blank');
      } catch (e) {
        // URL解析失败，直接打开
        window.open(videoUrl, '_blank');
      }
    },

    /**
     * 加载产品分类
     */
    loadCategories() {
      this.loadingCategories = true;
      this.categoryError = false;

      this.axios.get('/data-serv/product/categorize')
        .then(response => {
          if (response.data.code === 0 && response.data.data) {
            this.categories = response.data.data;
          } else {
            throw new Error(response.data.message || '获取分类失败');
          }
        })
        .catch(error => {
          console.error('加载分类出错:', error);
          this.categoryError = true;
        })
        .finally(() => {
          this.loadingCategories = false;
        });
    },

    /**
     * 获取产品数据
     */
    fetchProductData() {
      this.loading = true;
      this.error = null;

      const requestData = {
        ...this.search,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      };

      // 移除空字符串值
      Object.keys(requestData).forEach(key => {
        if (requestData[key] === '' || requestData[key] === null || requestData[key] === undefined) {
          delete requestData[key];
        }
      });

      this.axios.post('/data-serv/product/list', requestData)
        .then(response => {
          if (response.data.code === 0 && response.data.data) {
            const data = response.data.data;
            this.pagination.totalItems = data.totalRows || 0;
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize);
            this.products = data.list || [];

            // 计算分页显示范围
            this.calculatePagination();
          } else {
            throw new Error(response.data.message || '获取产品数据失败');
          }
        })
        .catch(error => {
          console.error('获取产品数据失败:', error);
          this.error = error.message || '获取产品数据失败';
          this.products = [];
          this.pagination.totalItems = 0;
          this.pagination.totalPages = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * 计算分页显示范围
     */
    calculatePagination() {
      const maxVisiblePages = 5;
      let startPage = Math.max(1, this.pagination.currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(this.pagination.totalPages, startPage + maxVisiblePages - 1);

      if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      this.pagination.startPage = startPage;
      this.pagination.endPage = endPage;

      // 生成页码数组
      this.pagination.pages = [];
      for (let i = startPage; i <= endPage; i++) {
        this.pagination.pages.push(i);
      }
    },

    /**
     * 处理搜索
     */
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchProductData();
    },

    /**
     * 处理页码变化
     */
    handlePageChange(page) {
      if (page < 1 || page > this.pagination.totalPages || page === this.pagination.currentPage) {
        return;
      }
      this.pagination.currentPage = page;
      this.fetchProductData();
    },

    /**
     * 处理每页条数变化
     */
    handlePageSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.currentPage = 1;
      this.fetchProductData();
    },

    /**
     * 处理编辑产品
     */
    handleEdit(sku) {
      // 获取当前页面的基础URL
      const baseUrl = window.location.origin;
      
      // 构建产品详情页的完整URL，直接访问产品详情页而不是通过/nav-bar
      const detailUrl = `${baseUrl}/product-detail?sku=${sku}`;
      
      // 在新标签页中打开产品详情页
      const newTab = window.open(detailUrl, '_blank');
      
      // 设置新标签页关闭时刷新数据
      if (newTab) {
        newTab.onbeforeunload = () => {
          this.fetchProductData();
        };
      }
    }
  },
  mounted() {
    // 组件挂载时加载分类和产品数据
    this.loadCategories();
    this.fetchProductData();
  }
}
</script>

<style scoped>
.product-index-container {
  padding: 20px;
}

.page-title {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.sticky-header {
  position: sticky;
  top: 70px;
  background-color: white;
  z-index: 1000;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

tbody tr:hover {
  background-color: #f5f5f5;
}

.edit-btn {
  padding: 5px 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.edit-btn:hover {
  background-color: #45a049;
}

.edit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.table-container {
  margin-top: 20px;
}

.product-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

.search-form {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
}

.search-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.search-row:last-child {
  margin-bottom: 0;
}

.search-col {
  flex: 0 0 25%;
  max-width: 25%;
  padding: 0 10px;
  box-sizing: border-box;
}

.search-button-col {
  display: flex;
  align-items: flex-end;
  padding-bottom: 10px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #495057;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 15px 0;
  border-top: 1px solid #e9ecef;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-size-selector span {
  font-size: 14px;
  color: #495057;
}


/* 响应式设计 */
@media (max-width: 1200px) {
  .search-col {
    flex: 0 0 33.333%;
    max-width: 33.333%;
  }
}

@media (max-width: 992px) {
  .search-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (max-width: 768px) {
  .search-row {
    flex-direction: column;
  }
  
  .search-col {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 15px;
  }
  
  .search-button-col {
    margin-top: 10px;
  }
  
  .pagination-container {
    flex-direction: column;
    gap: 20px;
  }
  
  .page-size-selector {
    justify-content: center;
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  th,
  td {
    padding: 6px 4px;
    font-size: 14px;
  }

  .product-img {
    width: 40px;
    height: 40px;
  }

  .edit-btn {
    padding: 4px 10px;
    font-size: 14px;
  }
}
</style>